<template>
<div>
  <about-title page-route="/sub/light-blocks/news/gallery" :title="$t('گالری')"></about-title>
  <v-container>
    <v-row>
      <v-col v-for="(item,i) in galleryItem.slice(0,2)" :key="i" cols="6">
      <BlockGalleryItem :item="item"/>
      </v-col>
    </v-row>
  </v-container>
  <div class="d-flex flex-column justify-center align-center">
    <div @click="$router.push({name:'baseGallery'})" class="skew px-8 py-3 pointer success white--text">بیشتر</div>
  </div>
</div>
</template>

<script>
import AboutTitle from "../../../About/Components/AboutTitle";
import BlockGalleryItem from "./BlockGalleryItem";
import {mapState} from "vuex";
export default {
  name: "gallery",
  components:{BlockGalleryItem, AboutTitle},
  data(){
    return{
      showImage:'',
      showImageDialog:false,
      galleryItem:[
        {
          id:1,
          title:'اردکان',
          file:require('../../../../../../../assets/images/news-images/4.jpg'),
          date:'۲۰۱۸-۳-۴',
          views:2
        },
        {
          id:2,
          title:'اردکان',
          file:require('../../../../../../../assets/images/news-images/4.jpg'),
          date:'۲۰۱۸-۳-۴',
          views:2
        },
        {
          id:3,
          title:'اردکان',
          file:require('../../../../../../../assets/images/news-images/4.jpg'),
          date:'۲۰۱۸-۳-۴',
          views:2
        },
        {
          id:4,
          title:'اردکان',
          file:require('../../../../../../../assets/images/news-images/4.jpg'),
          date:'۲۰۱۸-۳-۴',
          views:2
        },

      ]
    }
  },
  methods:{
    dialogBox(item){
      this.showImageDialog=true;
      this.showImage=item.file;

    }
  },
  created() {
    this.$store.dispatch('lightBlocksManagement/getBlockGallery');
  },
  computed:{
    ...mapState({
      galleryItem:state => state.lightBlocksManagement.blockGallery,
    })
  }
}
</script>

<style scoped>
.date-box{
  padding: 0 10px;
  text-align: center;
  position: absolute;
  bottom: 0;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(0, 0, 0, 0.6);
}
.g-box:hover>*>*>.date-box{
  background-color: #0846be;
  transition: all 0.3s cubic-bezier(0.7, 0.01, 0.3, 1);
}
.date-box>*{
  color: white;
  font-size: 16px !important;
}
.skew:hover{
  background-color: #AFAFAF !important;
}
</style>